module.exports = __webpack_public_path__ + "static/img/view4-1.ccef0b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view4-1.png
// module id = ZSoq
// module chunks = 1